module.exports = __webpack_public_path__ + "img/microplastics-inspect-medium.435f1cda.png";